import React, { useState, useEffect } from 'react';
import {
    Box,
    Paper,
    Typography,
    Button,
    Collapse,
    Alert,
    Link,
    IconButton,
    useTheme,
    alpha
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';

const DisclaimerBanner = () => {
    const [open, setOpen] = useState(true);
    const theme = useTheme();

    // Check if the user has dismissed the disclaimer before
    useEffect(() => {
        const hasSeenDisclaimer = localStorage.getItem('hasSeenDisclaimer');
        if (hasSeenDisclaimer) {
            setOpen(false);
        }
    }, []);

    const handleClose = () => {
        setOpen(false);
        // Store that user has seen the disclaimer
        localStorage.setItem('hasSeenDisclaimer', 'true');
    };

    if (!open) return null;

    return (
        <Collapse in={open}>
            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    mb: 3,
                    borderRadius: 2,
                    background: 'linear-gradient(to right, rgba(33, 150, 243, 0.05), rgba(33, 150, 243, 0.1))',
                    border: '1px solid rgba(33, 150, 243, 0.2)',
                    position: 'relative',
                }}
            >
                <IconButton
                    size="small"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.text.secondary,
                    }}
                    aria-label="close"
                >
                    <CloseIcon fontSize="small" />
                </IconButton>

                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                    <InfoIcon
                        sx={{
                            color: theme.palette.primary.main,
                            mr: 1.5,
                            mt: 0.5,
                            fontSize: '1.5rem'
                        }}
                    />
                    <Typography variant="h6" gutterBottom>
                        AI-Assisted Literature Review Tool
                    </Typography>
                </Box>

                <Typography variant="body2" sx={{ mb: 1.5, pl: 4 }}>
                    LitLLM helps you find and synthesize academic papers relevant to your research. This tool leverages AI to assist in literature reviews,
                    but all generated content should be reviewed for accuracy.
                    <strong> Remember to cite all sources appropriately in your final work.</strong>
                </Typography>

                <Typography variant="body2" sx={{ mb: 2, pl: 4 }}>
                    By using this tool, you acknowledge that AI-generated content may contain errors or omissions.
                    Always verify information against original sources before inclusion in academic work.
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={handleClose}
                        sx={{
                            borderRadius: '20px',
                            px: 2,
                            boxShadow: `0px 2px 6px ${alpha(theme.palette.primary.main, 0.2)}`
                        }}
                    >
                        I Understand
                    </Button>
                </Box>
            </Paper>
        </Collapse>
    );
};

export default DisclaimerBanner; 